export default "__VITE_ASSET__e8a07613__"